import { useLocation, useNavigate } from "react-router-dom";

import { casePaths } from "routes/case/paths";

/**
 * Opens the Case edit page. The current location travels as `from`, so
 * Cancel returns to where the user started.
 */
export const useCaseNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = { from: `${location.pathname}${location.search}` };

  return {
    openEdit: id => navigate(casePaths.edit(id), { state }),
  };
};
